import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
  subtitle?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'lg',
  text = 'Loading...',
  subtitle,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  // If no text is provided or it's just "Loading...", render as inline spinner
  const isInline = !text || text === 'Loading...';

  if (isInline) {
    return (
      <div 
        className={`${sizeClasses[size]} border-primary border-2 border-t-transparent rounded-full animate-spin ${className}`}
      ></div>
    );
  }

  return (
    <div className={`min-h-screen bg-background flex items-center justify-center px-4 ${className}`}>
      <div className="text-center space-y-6 max-w-md">
        {/* Primary colored spinning animation */}
        <div className="flex justify-center">
          <div 
            className={`${sizeClasses[size]} border-primary border-4 border-t-transparent rounded-full animate-spin`}
          ></div>
        </div>
        
        {/* Text content */}
        <div className="space-y-3">
          <h3 className="text-2xl font-bold text-secondary">{text}</h3>
          {subtitle && (
            <p className="text-gray-600 leading-relaxed">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 